var gql = require("graphql-tag");

const MUTATE_EMPTY_REGION_SEARCH = gql`
    mutation($region_id: Int, $region_name: String, $value: String) {
        emptyRegionSearch(
            region_id: $region_id
            region_name: $region_name
            value: $value
        )
    }
`;

export default MUTATE_EMPTY_REGION_SEARCH;
